import {Injectable} from '@angular/core';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {CategoryStructure} from '../core/entities/entities';
import {HttpService} from '../core/services/http.service';
import {ServiceName} from '../core/services/Service';

@Injectable()
export class CategoryStructureService extends HttpServiceBase<CategoryStructure> {
  getCleanInstance(): CategoryStructure {
    return new CategoryStructure();
  }

  public hasSingleGet() {
    return false;
  }

  public refreshOnRouteChange() {
    return false;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  public fromJson(json): CategoryStructure {
    const me = this;
    const item: CategoryStructure = Object.assign(this.getCleanInstance(), json);
    item.id = item.brandId + '_' + item.categoryId + '_' + item.productStructureId;
    return item;
  }

  getUrl() {
    return  'categoryStructure';
  }


}
ServiceName.add('CategoryStructureService', CategoryStructureService);



// WEBPACK FOOTER //
// ./src/app/services/category-structure.service.ts